import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import editPencilIcon from '../../../assets/img/icons/edit-pencil.svg';
import TableCustomCheckboxDropdownPill from '../../../components/CustomCheckboxDropdown/TableCustomCheckboxDropdownPill';
import ComponentCircleLoader from '../../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../../components/NoDataComponent/NoDataComponent';
import TaskActionTooltip from '../../../components/Tooltip/TaskActionTooltip';
import { TableItem } from '../../../styledComponents/ProjectsNew';
import BuildinIcon from '../../../assets/img/icons/building.svg';
import {
  CommonImage,
  Container,
  TableText,
} from '../../../styledComponents/common';
import {
  EditButton,
  ListBody,
  ListContainer,
  ListItem,
  MasterTaskTable,
  SubTaskItem,
  SubTaskList,
} from '../../../styledComponents/tasks';
import { EditButtonIcon } from '../tasksStyles';
import TaskDuration from 'components/TaskDuration/TaskDuration';

const MasterTasksList = ({
  masterTasksList,
  editMasterTask,
  isLoading = false,
}) => {
  const { t } = useTranslation();
  const [openedOfficeDropdown, setOpenedOfficeDropdown] = useState(null);

  const handleOfficeDropdownClick = id => {
    if (openedOfficeDropdown === id) {
      setOpenedOfficeDropdown(null);
    } else {
      setOpenedOfficeDropdown(id);
    }
  };

  const handleEdit = task => {
    const updatedTask = { ...task, name: task.name };
    editMasterTask({ task_id: task.id, ...updatedTask });
  };

  return (
    <Container style={{ paddingBottom: '20px' }}>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : masterTasksList && masterTasksList.length > 0 ? (
        <>
          <MasterTaskTable heading>
            <TableItem>
              <TableText>{t('task_code')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('name')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('related_offices')}</TableText>
            </TableItem>
            {/* <TableItem>
              <TableText>{t('default_task_duration')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('max_task_duration')}</TableText>
            </TableItem> */}
            <TableItem>
              <TableText />
            </TableItem>
          </MasterTaskTable>
          {masterTasksList?.map((task, i) => (
            <MasterTaskTable key={task.id}>
              <TableItem>
                <TableText>{task.code}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{task.name}</TableText>
              </TableItem>
              <TableItem>
                {task.related_office && task.related_office.length > 0 ? (
                  <TableCustomCheckboxDropdownPill
                    opened={openedOfficeDropdown === task.id}
                    options={task.related_office.map(office => ({
                      label: office.name,
                      value: office.id,
                    }))}
                    selectedOptions={task.related_office.map(office => ({
                      label: office.name,
                      value: office.id,
                    }))}
                    onClick={() => handleOfficeDropdownClick(task.id)}
                    onChange={() => {}} // Read-only, no changes needed
                    placeholder="related_offices"
                    countLabel="offices_selected"
                    icon={<CommonImage src={BuildinIcon} alt="offices" />}
                  />
                ) : (
                  <TableText>{t('no_offices')}</TableText>
                )}
              </TableItem>
              {/* <TableItem> */}
                {/* <TableText>
                  {task.default_task_duration
                    ? `${task.default_task_duration} h`
                    : `${t('not_set')}`}
                </TableText> */}
                {/* <TaskDuration type="clock" text={task.default_task_duration ? `${task.default_task_duration} h` : t('not_set')} /> */}
              {/* </TableItem> */}
              {/* <TableItem> */}
                {/* <TableText>
                  {task.max_task_duration
                    ? `${task.max_task_duration} h`
                    : `${t('not_set')}`}
                </TableText> */}
                {/* <TaskDuration type="stopwatch" text={task.max_task_duration ? `${task.max_task_duration} h` : t('not_set')} /> */}
              {/* </TableItem> */}
              <TableItem>
                <EditButtonIcon onClick={() => handleEdit(task)} title={t('edit_task')}>
                  <CommonImage src={editPencilIcon} alt="" />
                </EditButtonIcon>
              </TableItem>
            </MasterTaskTable>
          ))}
        </>
      ) : (
        <NoDataComponent
          title={t('no_master_tasks_found')}
          padding="5vh 0"
          imageHeight="140px"
        />
      )}
    </Container>
  );
};

export default MasterTasksList;
